/* eslint-disable*/
import React, { useState, useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import './MultiSelectDropdown.css';

const MultiSelectDropdown = ({ 
  options = [], 
  selectedValues = [], 
  onChange, 
  placeholder = "Select options...",
  searchPlaceholder = "Search...",
  onSearch,
  className = "",
  disabled = false,
  valueKey = "pick_name",
  displayKey = "pick_name"
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredOptions, setFilteredOptions] = useState(options);
  const dropdownRef = useRef(null);
  const searchInputRef = useRef(null);

  // Filter options based on search term
  useEffect(() => {
    if (searchTerm.trim() === '') {
      setFilteredOptions(options);
    } else {
      const filtered = options.filter(option =>
        option[displayKey]?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        option.pick_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        option.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        option.user_fullname?.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredOptions(filtered);
    }
  }, [searchTerm, options]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        setSearchTerm('');
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Focus search input when dropdown opens
  useEffect(() => {
    if (isOpen && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [isOpen]);

  const handleToggleDropdown = () => {
    if (!disabled) {
      setIsOpen(!isOpen);
      if (!isOpen) {
        setSearchTerm('');
      }
    }
  };

  const handleOptionToggle = (optionValue) => {
    const newSelectedValues = selectedValues.includes(optionValue)
      ? selectedValues.filter(value => value !== optionValue)
      : [...selectedValues, optionValue];
    
    onChange(newSelectedValues);
  };

  const handleSelectAll = () => {
    const allValues = filteredOptions.map(option => option.pick_name);
    const newSelectedValues = [...new Set([...selectedValues, ...allValues])];
    onChange(newSelectedValues);
  };

  const handleClearAll = () => {
    const filteredValues = filteredOptions.map(option => option.pick_name);
    const newSelectedValues = selectedValues.filter(value => !filteredValues.includes(value));
    onChange(newSelectedValues);
  };

  const handleSearch = () => {
    if (onSearch) {
      onSearch(selectedValues);
    }
    setIsOpen(false);
    setSearchTerm('');
  };

  // const getDisplayText = () => {
  //   if (selectedValues.length === 0) {
  //     return placeholder;
  //   }
  //   if (selectedValues.length === 1) {
  //     return selectedValues[0];
  //   }
  //   if (selectedValues.length <= 3) {
  //     return selectedValues.join(', ');
  //   }
  //   return `${selectedValues.length} selected`;
  // };

  const getDisplayText = () => {
  if (selectedValues.length === 0) {
    return placeholder;
  }
  // Map selected IDs to display names
  const selectedNames = options
    .filter(option => selectedValues.includes(option[valueKey]))
    .map(option => option[displayKey] || option.pick_name || option.name || option.user_fullname);

  if (selectedNames.length === 1) {
    return selectedNames[0];
  }
  if (selectedNames.length <= 3) {
    return selectedNames.join(', ');
  }
  return `${selectedNames.length} selected`;
};


  const getSelectedCount = () => {
    return selectedValues.length;
  };

  return (
    <div className={`multi-select-dropdown ${className}`} ref={dropdownRef}>
      <div className="multi-select-input-container">
        <div 
          className={`multi-select-input ${isOpen ? 'open' : ''} ${disabled ? 'disabled' : ''}`}
          onClick={handleToggleDropdown}
        >
          <span className="multi-select-text">
            {getDisplayText()}
          </span>
          <span className="multi-select-arrow">
            {isOpen ? '▲' : '▼'}
          </span>
        </div>
        
        <button
          type="button"
          className="multi-select-search-btn"
          onClick={handleSearch}
          disabled={disabled}
          title="Search"
        >
          <FontAwesomeIcon icon={faSearch} />
        </button>
      </div>

      {isOpen && (
        <div className="multi-select-dropdown-menu">
          {/* <div className="multi-select-search-container">
            <input
              ref={searchInputRef}
              type="text"
              placeholder={searchPlaceholder}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="multi-select-search-input"
            />
          </div> */}
          
          {/* <div className="multi-select-actions">
            <button
              type="button"
              className="multi-select-action-btn"
              onClick={handleSelectAll}
            >
              Select All
            </button>
            <button
              type="button"
              className="multi-select-action-btn"
              onClick={handleClearAll}
            >
              Clear All
            </button>
          </div> */}

          <div className="multi-select-options">
            {filteredOptions.length === 0 ? (
              <div className="multi-select-no-options">
                No options found
              </div>
            ) : (
              filteredOptions.map((option, index) => {
                const optionValue = option[valueKey];
                const isSelected = selectedValues.includes(optionValue);
                return (
                  <div
                    key={index}
                    className={`multi-select-option ${isSelected ? 'selected' : ''}`}
                    onClick={() => handleOptionToggle(optionValue)}
                  >
                    <span className="multi-select-option-text">
                      {option[displayKey] || option.pick_name || option.name || option.user_fullname}
                    </span>
                    {isSelected && (
                      <span className="multi-select-check">
                        <FontAwesomeIcon icon={faCheck} />
                      </span>
                    )}
                  </div>
                );
              })
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default MultiSelectDropdown;
